export const locale = {
    lang: "en-US",
    data: {
        SAMPLE: {
            HELLO: "Hello, World!"
        }
    }
};
